/**
 * Data digital survey mock
 */

// Utils
import { RowHeader } from 'utils/types';
import { IParamGetList } from 'models/UserRequest';
import { ParamsGetListSetting } from 'utils/constants';

export const headerDigitalSurvey: RowHeader[] = [
  { id: 'id', label: 'No', position: 'center', haveSort: false },
  { id: 'status', label: '利用状況', haveSort: false },
  { id: 'user_company', label: '企業名/団体名' },
  { id: 'user_department', label: '所属' },
  { id: 'user_name', label: '名前' },
  { id: 'user_email', label: 'メールアドレス' },
  { id: 'title', label: 'イベント名' },
  { id: 'questionnaires_title', label: 'アンケート名' },
  { id: 'start_date', label: '開催日' },
  { id: 'end_date', label: '終了日' },
  { id: 'paper_questionnaire_answer_id', label: '紙アンケート有無' },
  { id: 'meter_square_num', label: '平米数' },
  { id: 'exhibit_cost', label: '出展費(円）' },
  { id: 'decoration_cost', label: '装飾費(円）' },
  { id: 'operation_cost', label: '運営費(円）' },
  { id: 'comment_cost', label: '総来場者数' },
  { id: 'cost_per_lead', label: 'リード単価(円)' },
  { id: 'number_questionnaire_answers', label: 'デジタルアンケート結果' },
  { id: 'number_of_business_cards', label: 'eas名刺数' },
  { id: 'number_of_questionnaires', label: 'easアンケート数' },
  { id: 'delete_item', label: '登録情報削除', position: 'center', haveSort: false },
];

export const defaultParamsDigitalSurvey: IParamGetList = {
  keyword: '',
  order_by: 'desc',
  sort_name: 'start_date',
  page: ParamsGetListSetting.DEFAULT_PAGE as number,
  per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
};
